import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';

import VueGtag from 'vue-gtag';
Vue.use(
  VueGtag,
  {
    config: { id: 'UA-26080797-1' },
  },
  router
);

import VueMeta from 'vue-meta';
Vue.use(VueMeta);

import ZoomOnHover from 'vue-zoom-on-hover';
Vue.use(ZoomOnHover);

import VueScrollactive from 'vue-scrollactive';
Vue.use(VueScrollactive);

//import LetItSnow from 'vue-let-it-snow';
//Vue.use(LetItSnow);

import 'vue-burger-button/dist/vue-burger-button.css';
import BurgerButton from 'vue-burger-button';

Vue.component('burger-button', BurgerButton);

Vue.config.productionTip = false;

// Matomo: praćenje klikova na broj telefona (GA4 to hvata preko GTM-a, event Phone_click).
// Delegirano na document u capture fazi — pokriva sve tel: linkove (traka #fixTel i naslovna)
// i stigne poslati događaj prije nego mobilni pretraživač otvori dijaler.
document.addEventListener(
  'click',
  (evt) => {
    const link =
      evt.target &&
      evt.target.closest &&
      evt.target.closest('a[href^="tel:"]');
    if (!link) return;
    window._paq = window._paq || [];
    window._paq.push([
      'trackEvent',
      'Kontakt',
      'Phone_click',
      window.location.pathname,
    ]);
  },
  true
);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
